export default __webpack_public_path__ + "static/media/play-solid.3c7578b0.svg";